export default "__VITE_ASSET__CfagYqMw__"